<template>
  <div>
    <v-app-bar color="primary" app dark>
      <v-app-bar-nav-icon @click="toggleSideBar()"></v-app-bar-nav-icon>
      <v-toolbar-title> Support Bot</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- Logout Button -->
      <v-btn icon @click="logout()">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer v-model="sideBarShown" app>
      <v-sheet class="pa-4">
        <v-avatar v-if="user" class="mb-4" color="grey darken-1" size="64">
          <v-img
            v-if="slackMap[user.slack_id]"
            :src="slackMap[user.slack_id].image"
          ></v-img>
          <v-icon v-else dark> mdi-account </v-icon>
        </v-avatar>
        <p>Hi {{ user.first_name }}</p>
      </v-sheet>

      <v-divider></v-divider>
      <v-list-item
        :to="route.path"
        v-for="(route, key) in routesMap"
        :key="key"
      >
        <v-list-item-icon>
          <v-icon> {{ route.meta.icon }} </v-icon>
        </v-list-item-icon>
        <v-list-item-title> {{ route.name }} </v-list-item-title>
      </v-list-item>
    </v-navigation-drawer>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
export default {
  props: {
    user: {
      type: Object,
    },
    slackMap: {
      type: Object,
    },
  },
  data() {
    return {
      sideBarShown: true,
      routesMap: {},
      defaultRoutes: [
        "Home",
        "Shifts",
        "Skips",
        "Change Log",
        "Account",
        "Service Status",
      ],
    };
  },
  methods: {
    toggleSideBar() {
      this.sideBarShown = !this.sideBarShown;
    },
    logout() {
      this.loggedIn = false;
      axios.post("/api/v1/user/logout");
      localStorage.removeItem("sessionToken");
      localStorage.removeItem("username");
      window.location.reload();
    },
  },
  mounted() {
    let routes = this.$router.options.routes;
    // Check if user has access to route or is admin
    this.routesMap = routes.filter((route) => {
      if (this.user.views.includes(route.name) || this.user.permissions.admin) {
        return true;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.v-list-item__title {
  color: white !important;
}
</style>
